export default __webpack_public_path__ + "static/media/bank.bb4a5a80.svg";